const outlets = {
  IDENTIFICATION: 'identification',
  CARD: 'card',
  MESSAGE: 'message',
  HELP: 'help',
  _BLANK: ''
};
export const Outlets = outlets;
